import React from 'react';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import { useTranslation } from 'next-i18next';
import styles from './card-image.module.scss';

type CardImageProps = {
  onClick: () => void;
  imageUrl: string;
  title?: string;
  icon?: string;
  dataCy?: string;
} & React.HTMLProps<HTMLButtonElement>;

const CardImage: React.FC<CardImageProps> = (props) => {
  const { t: tA11y } = useTranslation('a11y');
  const { onClick, imageUrl = '', title, icon, dataCy } = props;

  return (
    <button
      type="button"
      onClick={onClick}
      className={styles.card}
      data-cy={dataCy}
    >
      <div
        className={styles.card__image}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      />
      {title && <span className={clsx(styles.card__title, 'vc-text-xl')}>{title}</span>}
      {icon && (
        <Icon
          name={icon}
          className={styles.card__icon}
          ariaLabel={tA11y('A11Y.ICON.ARROW_NEXT')}
        />
      )}
    </button>
  );
};

export default CardImage;
